// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2y6ED","tab":"ProcedureTabs_tab__25iQE"};